import type { ButtonRadiusSelectorType } from ".";
import type { IconType } from "@circle-react-shared/Icon";

export const BUTTON_RADIUS_SELECTOR_TYPES: {
  type: ButtonRadiusSelectorType;
  icon: IconType;
}[] = [
  {
    type: "all",
    icon: "20-all-corners",
  },
  {
    type: "individual",
    icon: "20-individual-corners",
  },
];

export const CORNERS = [
  "border-left-top-radius",
  "border-left-bottom-radius",
  "border-right-top-radius",
  "border-right-bottom-radius",
] as const;
